import React, { useState, useEffect } from 'react';
import { Search, MapPin, Briefcase, Clock, X, CheckCircle, Phone, Mail, DollarSign, GraduationCap, Calendar, Users, Award, BookOpen } from 'lucide-react';
import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js';
import { getFirestore, collection, addDoc } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js';
import { FaMoneyBill, FaRupeeSign } from 'react-icons/fa';

// Firebase configuration - REPLACE WITH YOUR ACTUAL CONFIG
const firebaseConfig = {
    apiKey: "AIzaSyAo8JAiRJUyz6ArJCHOCwEqHQEmfbWgtgA",
    authDomain: "olewin-academy.firebaseapp.com",
    projectId: "olewin-academy",
    storageBucket: "olewin-academy.appspot.com",
    messagingSenderId: "622543323365",
    appId: "1:622543323365:web:9a3e28d5c63850d60e940c",
    measurementId: "G-09WHHRMJRC"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const InternshipsPortal = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedInternship, setSelectedInternship] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [filteredInternships, setFilteredInternships] = useState([]);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    college: '',
    degree: '',
    branch: '',
    year: '',
    cgpa: '',
    careerGap: '',
    gapReason: '',
    skills: '',
    previousInternships: '',
    projects: '',
    linkedin: '',
    github: '',
    portfolio: '',
    whyApply: '',
    availability: '',
    internshipRole: ''
  });

  const contactNumber = "+91-8639449423";
  const contactEmail = "olewinacademy@gmail.com";

  const internshipListings = [
    {
      id: 1,
      title: "Full Stack Development Internship",
      department: "Web Development",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹20,000 - ₹35,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Work on real-time company projects building full-stack web applications using modern technologies. Gain hands-on experience with React, Node.js, and databases.",
      responsibilities: [
        "Develop responsive web applications using React.js and Node.js",
        "Build RESTful APIs and integrate with databases",
        "Collaborate with senior developers on real company projects",
        "Write clean, maintainable, and documented code",
        "Participate in code reviews and daily standups",
        "Learn industry best practices and modern development workflows"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) are welcome",
        "Basic knowledge of HTML, CSS, JavaScript",
        "Understanding of programming fundamentals",
        "Eagerness to learn and work on real projects",
        "Good communication skills and team player"
      ],
      learningOutcomes: [
        "Master full-stack development with React and Node.js",
        "Experience working on live company projects",
        "Learn Git, version control, and collaborative coding",
        "Understand Agile methodologies and sprint planning",
        "Build a strong portfolio with real-world projects",
        "Get mentorship from experienced developers"
      ],
      skills: ["React.js", "Node.js", "JavaScript", "HTML/CSS", "MongoDB", "Git"],
      projects: "E-commerce platform, LMS dashboard, Social media app"
    },
    {
      id: 2,
      title: "Mobile App Development Internship (React Native)",
      department: "Mobile Development",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹18,000 - ₹30,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build cross-platform mobile applications for real company projects. Learn React Native and mobile app development from industry experts.",
      responsibilities: [
        "Develop mobile apps using React Native for iOS and Android",
        "Implement UI/UX designs and integrate APIs",
        "Test apps on different devices and fix bugs",
        "Work on real-time educational and business applications",
        "Collaborate with designers and backend developers",
        "Learn mobile app deployment and publishing"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic JavaScript knowledge",
        "Interest in mobile app development",
        "Problem-solving mindset",
        "Available for 3-6 months commitment"
      ],
      learningOutcomes: [
        "Master React Native mobile development",
        "Build and publish apps to Play Store and App Store",
        "Learn mobile UI/UX best practices",
        "Work with Firebase and backend integration",
        "Understand mobile app architecture",
        "Create impressive mobile app portfolio"
      ],
      skills: ["React Native", "JavaScript", "Mobile UI", "Firebase", "REST API", "Git"],
      projects: "Educational app, E-commerce mobile app, Social networking app"
    },
    {
      id: 3,
      title: "AI/ML Internship",
      department: "Artificial Intelligence",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "₹25,000 - ₹40,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Work on cutting-edge AI/ML projects including predictive models, NLP, and computer vision for real company applications.",
      responsibilities: [
        "Build machine learning models for real-world problems",
        "Work on NLP projects for educational content analysis",
        "Develop computer vision solutions",
        "Collect, clean, and preprocess datasets",
        "Train and evaluate ML models",
        "Document experiments and create presentations"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong foundation in Python programming",
        "Basic understanding of ML concepts",
        "Knowledge of mathematics and statistics",
        "Passion for AI and continuous learning"
      ],
      learningOutcomes: [
        "Hands-on experience with TensorFlow and PyTorch",
        "Build predictive models and recommendation systems",
        "Learn data preprocessing and feature engineering",
        "Work on real company AI/ML projects",
        "Understand MLOps and model deployment",
        "Build strong AI/ML portfolio"
      ],
      skills: ["Python", "Machine Learning", "TensorFlow", "PyTorch", "NLP", "Data Analysis"],
      projects: "Student performance prediction, Content recommendation system, OCR system"
    },
    {
      id: 4,
      title: "Data Science Internship",
      department: "Data Science",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹22,000 - ₹38,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Analyze educational data, build dashboards, and create insights for data-driven decision making in real company projects.",
      responsibilities: [
        "Analyze large datasets and extract meaningful insights",
        "Create data visualizations and dashboards",
        "Build statistical models and reports",
        "Work on A/B testing and experimentation",
        "Collaborate with product teams on data-driven features",
        "Present findings to stakeholders"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Proficiency in Python or R",
        "Basic knowledge of statistics",
        "Understanding of SQL",
        "Analytical mindset and curiosity"
      ],
      learningOutcomes: [
        "Master data analysis with Python and pandas",
        "Learn data visualization with Tableau/Power BI",
        "Build statistical models and hypothesis testing",
        "Work with real company datasets",
        "Create professional dashboards and reports",
        "Understand business intelligence and analytics"
      ],
      skills: ["Python", "SQL", "Data Analysis", "Statistics", "Tableau", "Excel"],
      projects: "User behavior analysis, Performance dashboards, Predictive analytics"
    },
    {
      id: 5,
      title: "Frontend Development Internship (React/Vue)",
      department: "Frontend Engineering",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹18,000 - ₹32,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Create beautiful, responsive user interfaces for real company websites and applications using modern frontend frameworks.",
      responsibilities: [
        "Develop responsive web interfaces using React or Vue.js",
        "Implement designs from Figma/Adobe XD",
        "Build reusable UI components",
        "Optimize web performance and accessibility",
        "Integrate APIs and manage state",
        "Write clean, semantic HTML and CSS"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong HTML, CSS, JavaScript fundamentals",
        "Basic understanding of React or Vue.js",
        "Eye for design and detail",
        "Portfolio of personal projects (preferred)"
      ],
      learningOutcomes: [
        "Master React.js or Vue.js framework",
        "Learn modern CSS frameworks (Bootstrap, Tailwind)",
        "Build pixel-perfect responsive designs",
        "Understand state management and hooks",
        "Work on real company UI projects",
        "Create stunning portfolio website"
      ],
      skills: ["React.js", "Vue.js", "HTML5", "CSS3", "JavaScript", "Responsive Design"],
      projects: "Landing pages, Admin dashboards, E-learning interfaces"
    },
    {
      id: 6,
      title: "Backend Development Internship (Node.js/Python)",
      department: "Backend Engineering",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹20,000 - ₹35,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build robust backend systems, APIs, and databases for real company projects using Node.js or Python.",
      responsibilities: [
        "Develop RESTful APIs using Node.js or Django/FastAPI",
        "Design and implement database schemas",
        "Write server-side business logic",
        "Implement authentication and authorization",
        "Optimize database queries and caching",
        "Write unit tests and API documentation"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Knowledge of Node.js or Python",
        "Understanding of databases (SQL/NoSQL)",
        "Basic knowledge of REST APIs",
        "Problem-solving skills"
      ],
      learningOutcomes: [
        "Master backend development with Node.js/Python",
        "Learn database design and optimization",
        "Build scalable APIs and microservices",
        "Understand authentication and security",
        "Work on real company backend projects",
        "Learn cloud deployment (AWS, Heroku)"
      ],
      skills: ["Node.js", "Python", "MongoDB", "PostgreSQL", "REST API", "Express.js"],
      projects: "API for mobile apps, CMS backend, Authentication system"
    },
    {
      id: 7,
      title: "UI/UX Design Internship",
      department: "Design",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹28,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Design user interfaces and experiences for real company products. Work on web and mobile app designs.",
      responsibilities: [
        "Create wireframes, mockups, and prototypes",
        "Design user interfaces for web and mobile applications",
        "Conduct user research and usability testing",
        "Create design systems and component libraries",
        "Collaborate with developers on implementation",
        "Present designs to stakeholders"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Proficiency in Figma or Adobe XD",
        "Understanding of design principles",
        "Creative and detail-oriented",
        "Portfolio of design work (preferred)"
      ],
      learningOutcomes: [
        "Master UI/UX design tools (Figma, Adobe XD)",
        "Learn user research methodologies",
        "Create professional design portfolios",
        "Understand design thinking and user psychology",
        "Work on real company design projects",
        "Learn interaction design and prototyping"
      ],
      skills: ["Figma", "Adobe XD", "UI Design", "UX Research", "Prototyping", "Wireframing"],
      projects: "Mobile app UI, Website redesign, Dashboard design"
    },
    {
      id: 8,
      title: "DevOps Internship",
      department: "Infrastructure",
      location: "Remote",
      duration: "4-6 months",
      stipend: "₹22,000 - ₹40,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn cloud infrastructure, CI/CD, and automation while working on real company DevOps projects.",
      responsibilities: [
        "Set up CI/CD pipelines for projects",
        "Manage cloud infrastructure (AWS/Azure/GCP)",
        "Automate deployment and monitoring",
        "Work with Docker and Kubernetes",
        "Implement logging and alerting systems",
        "Learn infrastructure as code"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic Linux/Unix knowledge",
        "Understanding of networking concepts",
        "Interest in cloud technologies",
        "Scripting knowledge (Bash/Python)"
      ],
      learningOutcomes: [
        "Master cloud platforms (AWS/Azure/GCP)",
        "Learn Docker and Kubernetes",
        "Build CI/CD pipelines",
        "Understand infrastructure automation",
        "Work on real company infrastructure",
        "Get cloud certifications guidance"
      ],
      skills: ["AWS", "Docker", "Kubernetes", "Linux", "CI/CD", "Python"],
      projects: "Cloud deployment automation, Monitoring setup, Container orchestration"
    },
    {
      id: 9,
      title: "LLM & Prompt Engineering Internship",
      department: "AI/ML",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹25,000 - ₹45,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Work with Large Language Models, build AI applications, and learn prompt engineering for real company AI projects.",
      responsibilities: [
        "Work with OpenAI, Anthropic APIs and open-source LLMs",
        "Develop prompt engineering strategies",
        "Build AI chatbots and assistants",
        "Implement RAG (Retrieval Augmented Generation) systems",
        "Fine-tune language models for specific use cases",
        "Create AI-powered educational tools"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong Python programming skills",
        "Interest in AI and language models",
        "Basic understanding of NLP concepts",
        "Creative problem-solving mindset"
      ],
      learningOutcomes: [
        "Master LLM APIs and prompt engineering",
        "Build AI applications with GPT-4, Claude",
        "Learn RAG and vector databases",
        "Implement chatbots and AI assistants",
        "Work on cutting-edge AI projects",
        "Understand fine-tuning and model optimization"
      ],
      skills: ["Python", "LLMs", "Prompt Engineering", "Langchain", "RAG", "OpenAI API"],
      projects: "AI tutor chatbot, Document Q&A system, Content generation tool"
    },
    {
      id: 10,
      title: "Agentic AI Development Internship",
      department: "AI/ML",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "₹28,000 - ₹50,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build autonomous AI agents that can reason, plan, and execute tasks for real company applications.",
      responsibilities: [
        "Develop multi-agent systems using LangGraph, AutoGPT",
        "Build autonomous AI agents for task automation",
        "Implement agent reasoning and planning",
        "Integrate agents with tools and APIs",
        "Work on educational AI assistant projects",
        "Research latest agentic AI techniques"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong Python and async programming",
        "Understanding of LLMs and AI agents",
        "Interest in autonomous systems",
        "Research mindset and curiosity"
      ],
      learningOutcomes: [
        "Master agentic AI frameworks (LangGraph, CrewAI)",
        "Build autonomous AI agents",
        "Learn agent architectures and patterns",
        "Work on cutting-edge AI agent projects",
        "Understand multi-agent coordination",
        "Contribute to AI research"
      ],
      skills: ["Python", "LangGraph", "Agentic AI", "LLMs", "AutoGPT", "Agent Architecture"],
      projects: "Autonomous research assistant, Task automation agents, Multi-agent systems"
    },
    {
      id: 11,
      title: "Computer Vision Internship",
      department: "AI/ML",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "₹23,000 - ₹40,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Work on image processing, object detection, and computer vision projects for real company applications.",
      responsibilities: [
        "Develop computer vision models for object detection",
        "Build image classification and segmentation systems",
        "Work on OCR and document processing",
        "Implement facial recognition systems",
        "Optimize models for real-time performance",
        "Create datasets and annotation pipelines"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Python and OpenCV knowledge",
        "Basic understanding of deep learning",
        "Interest in computer vision",
        "Strong mathematical foundation"
      ],
      learningOutcomes: [
        "Master OpenCV and computer vision",
        "Build CNN models with TensorFlow/PyTorch",
        "Learn object detection (YOLO, R-CNN)",
        "Work on real CV projects",
        "Understand image processing techniques",
        "Deploy CV models in production"
      ],
      skills: ["Python", "OpenCV", "TensorFlow", "PyTorch", "Computer Vision", "Deep Learning"],
      projects: "Document scanner, Face attendance system, Object detection app"
    },
    {
      id: 12,
      title: "Flutter App Development Internship",
      department: "Mobile Development",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹18,000 - ₹32,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build beautiful cross-platform mobile apps using Flutter for real company projects.",
      responsibilities: [
        "Develop mobile applications using Flutter and Dart",
        "Implement responsive UI designs",
        "Integrate REST APIs and Firebase",
        "Handle state management",
        "Test apps on Android and iOS",
        "Publish apps to app stores"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic programming knowledge",
        "Interest in mobile app development",
        "Willingness to learn Dart and Flutter",
        "Creative and detail-oriented"
      ],
      learningOutcomes: [
        "Master Flutter and Dart programming",
        "Build and publish mobile apps",
        "Learn state management (Provider, Bloc)",
        "Work with Firebase and backend APIs",
        "Create professional mobile app portfolio",
        "Understand mobile app architecture"
      ],
      skills: ["Flutter", "Dart", "Firebase", "Mobile UI", "State Management", "REST API"],
      projects: "E-learning mobile app, Task manager, Social media app"
    },
    {
      id: 13,
      title: "Blockchain Development Internship",
      department: "Emerging Tech",
      location: "Remote",
      duration: "4-6 months",
      stipend: "₹25,000 - ₹45,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn blockchain technology and build decentralized applications for real company projects.",
      responsibilities: [
        "Develop smart contracts using Solidity",
        "Build decentralized applications (DApps)",
        "Implement blockchain-based certificate verification",
        "Work with Web3 technologies",
        "Test and deploy smart contracts",
        "Learn blockchain security best practices"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong programming fundamentals",
        "Interest in blockchain and Web3",
        "Basic understanding of cryptography",
        "Problem-solving mindset"
      ],
      learningOutcomes: [
        "Master Solidity and smart contract development",
        "Build DApps with Web3.js",
        "Understand blockchain architecture",
        "Work on real blockchain projects",
        "Learn crypto wallets and transactions",
        "Deploy on Ethereum and other networks"
      ],
      skills: ["Solidity", "Ethereum", "Web3.js", "Smart Contracts", "Blockchain", "DApps"],
      projects: "Certificate verification system, NFT marketplace, DApp development"
    },
    {
      id: 14,
      title: "Cloud Computing Internship",
      department: "Infrastructure",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹20,000 - ₹38,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn cloud platforms (AWS, Azure, GCP) and work on cloud infrastructure projects.",
      responsibilities: [
        "Learn cloud services and architecture",
        "Deploy applications on cloud platforms",
        "Manage virtual machines and databases",
        "Implement cloud security measures",
        "Work on serverless architectures",
        "Monitor and optimize cloud costs"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic networking knowledge",
        "Interest in cloud technologies",
        "Linux/Windows server basics",
        "Willingness to get cloud certifications"
      ],
      learningOutcomes: [
        "Master AWS/Azure/GCP platforms",
        "Deploy scalable cloud applications",
        "Learn cloud architecture patterns",
        "Get cloud certification guidance",
        "Work on real cloud projects",
        "Understand DevOps and cloud integration"
      ],
      skills: ["AWS", "Azure", "GCP", "Cloud Architecture", "Serverless", "Linux"],
      projects: "Web app deployment, Database migration, Serverless API"
    },
    {
      id: 15,
      title: "Cybersecurity Internship",
      department: "Security",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "₹22,000 - ₹42,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn ethical hacking, security testing, and vulnerability assessment for real company systems.",
      responsibilities: [
        "Conduct security assessments and penetration testing",
        "Identify and report security vulnerabilities",
        "Learn ethical hacking techniques",
        "Implement security measures",
        "Work on security automation",
        "Study latest security threats and solutions"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Interest in cybersecurity and ethical hacking",
        "Basic networking knowledge",
        "Understanding of OS and systems",
        "Ethical mindset and responsibility"
      ],
      learningOutcomes: [
        "Learn ethical hacking and penetration testing",
        "Understand OWASP Top 10 vulnerabilities",
        "Master security tools (Burp Suite, Metasploit)",
        "Work on real security assessments",
        "Get CEH certification guidance",
        "Build cybersecurity career"
      ],
      skills: ["Ethical Hacking", "Penetration Testing", "OWASP", "Security Tools", "Network Security", "Linux"],
      projects: "Web app security testing, Network vulnerability assessment, Security automation"
    },
    {
      id: 16,
      title: "Digital Marketing Internship",
      department: "Marketing",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹28,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn SEO, social media marketing, content marketing for real company campaigns.",
      responsibilities: [
        "Manage social media accounts and campaigns",
        "Create content for blogs and social media",
        "Learn SEO and keyword research",
        "Run paid advertising campaigns",
        "Analyze marketing metrics and ROI",
        "Work on email marketing campaigns"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Good communication and writing skills",
        "Creative and analytical mindset",
        "Interest in digital marketing",
        "Basic understanding of social media"
      ],
      learningOutcomes: [
        "Master SEO and content marketing",
        "Learn social media strategies",
        "Run Google Ads and Facebook Ads",
        "Understand marketing analytics",
        "Work on real marketing campaigns",
        "Get Google and HubSpot certifications"
      ],
      skills: ["SEO", "Social Media Marketing", "Content Writing", "Google Ads", "Analytics", "Email Marketing"],
      projects: "Social media campaigns, SEO optimization, Content marketing strategy"
    },
    {
      id: 17,
      title: "Game Development Internship (Unity)",
      department: "Game Development",
      location: "Remote",
      duration: "4-6 months",
      stipend: "₹20,000 - ₹38,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build educational games and interactive experiences using Unity for real company projects.",
      responsibilities: [
        "Develop 2D/3D games using Unity",
        "Implement game mechanics and physics",
        "Create educational game experiences",
        "Work with Unity assets and animations",
        "Optimize game performance",
        "Test and debug games"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic C# programming knowledge",
        "Interest in game development",
        "Creative and problem-solving skills",
        "Passion for gaming"
      ],
      learningOutcomes: [
        "Master Unity game engine",
        "Learn C# game programming",
        "Build 2D and 3D games",
        "Understand game design principles",
        "Work on real game projects",
        "Create game development portfolio"
      ],
      skills: ["Unity", "C#", "Game Development", "Game Design", "2D/3D Graphics", "Physics"],
      projects: "Educational puzzle game, Quiz game, Adventure learning game"
    },
    {
      id: 18,
      title: "AR/VR Development Internship",
      department: "Immersive Tech",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "₹25,000 - ₹45,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Create immersive AR/VR experiences for educational and training applications.",
      responsibilities: [
        "Develop AR/VR applications using Unity",
        "Create 3D immersive environments",
        "Implement user interactions in VR",
        "Work on AR mobile applications",
        "Optimize VR performance",
        "Test on VR headsets and AR devices"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Unity and C# knowledge",
        "Interest in AR/VR technologies",
        "3D graphics understanding",
        "Innovative and creative mindset"
      ],
       learningOutcomes: [
        "Master AR/VR development with Unity",
        "Learn ARKit, ARCore, and VR SDKs",
        "Build immersive learning experiences",
        "Understand spatial computing",
        "Work on real AR/VR projects",
        "Create impressive AR/VR portfolio"
      ],
      skills: ["Unity", "AR/VR", "C#", "ARKit", "ARCore", "3D Graphics"],
      projects: "Virtual lab simulation, AR learning app, VR training module"
    },
    {
      id: 19,
      title: "IoT Development Internship",
      department: "IoT",
      location: "Hybrid",
      duration: "3-6 months",
      stipend: "₹20,000 - ₹35,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build IoT solutions for smart devices and sensor-based applications.",
      responsibilities: [
        "Develop IoT applications and firmware",
        "Work with sensors and microcontrollers",
        "Implement device-to-cloud communication",
        "Build IoT dashboards",
        "Work on Arduino, Raspberry Pi projects",
        "Learn IoT security and protocols"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic programming knowledge (C/Python)",
        "Interest in electronics and IoT",
        "Hardware tinkering experience (preferred)",
        "Problem-solving skills"
      ],
      learningOutcomes: [
        "Master IoT development",
        "Work with Arduino, ESP32, Raspberry Pi",
        "Learn MQTT and IoT protocols",
        "Build sensor-based applications",
        "Integrate IoT with cloud platforms",
        "Create IoT project portfolio"
      ],
      skills: ["IoT", "Arduino", "Raspberry Pi", "Python", "MQTT", "Sensors"],
      projects: "Smart classroom system, Environmental monitoring, Home automation"
    },
    {
      id: 20,
      title: "Quality Assurance (QA) Testing Internship",
      department: "Quality Assurance",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹28,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn software testing, automation, and quality assurance for real company products.",
      responsibilities: [
        "Perform manual and automated testing",
        "Write test cases and test plans",
        "Report and track bugs",
        "Learn automation tools (Selenium, Cypress)",
        "Conduct regression and integration testing",
        "Work with development teams"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Attention to detail",
        "Basic programming knowledge",
        "Analytical mindset",
        "Good communication skills"
      ],
      learningOutcomes: [
        "Master software testing methodologies",
        "Learn test automation with Selenium",
        "Understand QA best practices",
        "Work on real product testing",
        "Get ISTQB certification guidance",
        "Build QA career foundation"
      ],
      skills: ["Manual Testing", "Automation Testing", "Selenium", "Test Cases", "Bug Tracking", "API Testing"],
      projects: "Web application testing, Mobile app QA, API testing automation"
    },
    {
      id: 21,
      title: "Video Editing & Production Internship",
      department: "Media Production",
      location: "Hybrid",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹30,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Create educational videos, edit content, and produce multimedia for real company projects.",
      responsibilities: [
        "Edit educational videos for online courses",
        "Create animations and motion graphics",
        "Record and produce video content",
        "Design thumbnails and graphics",
        "Work with Adobe Premiere, After Effects",
        "Optimize videos for different platforms"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Interest in video editing",
        "Creative and artistic skills",
        "Basic video editing software knowledge",
        "Good storytelling sense"
      ],
      learningOutcomes: [
        "Master Adobe Premiere and After Effects",
        "Learn video production workflow",
        "Create professional video content",
        "Understand motion graphics",
        "Work on real video projects",
        "Build video production portfolio"
      ],
      skills: ["Video Editing", "Adobe Premiere", "After Effects", "Motion Graphics", "Storytelling", "Color Grading"],
      projects: "Course videos, Promotional content, Tutorial series"
    },
    {
      id: 22,
      title: "Content Writing & Marketing Internship",
      department: "Content",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹25,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Write technical content, blogs, and marketing materials for real company platforms.",
      responsibilities: [
        "Write blog posts and technical articles",
        "Create course content and documentation",
        "Develop marketing copy",
        "Research and write on technical topics",
        "Edit and proofread content",
        "Optimize content for SEO"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Excellent writing and grammar skills",
        "Interest in technology and education",
        "Creative thinking",
        "Research skills"
      ],
      learningOutcomes: [
        "Master technical and creative writing",
        "Learn content strategy and SEO",
        "Build professional writing portfolio",
        "Understand content marketing",
        "Work on real content projects",
        "Develop editorial skills"
      ],
      skills: ["Content Writing", "Technical Writing", "SEO", "Research", "Editing", "Marketing Copy"],
      projects: "Technical blog posts, Course content, Marketing materials"
    },
    {
      id: 23,
      title: "Business Analytics Internship",
      department: "Business Intelligence",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹18,000 - ₹32,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Analyze business data, create reports, and provide insights for decision-making.",
      responsibilities: [
        "Analyze business metrics and KPIs",
        "Create dashboards and reports",
        "Conduct market research",
        "Work with Excel, SQL, Power BI",
        "Present findings to stakeholders",
        "Support business decision-making"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong analytical skills",
        "Proficiency in Excel",
        "Basic SQL knowledge",
        "Business acumen"
      ],
      learningOutcomes: [
        "Master business analytics tools",
        "Learn Power BI and Tableau",
        "Understand business metrics",
        "Work on real business problems",
        "Develop data storytelling skills",
        "Build analytics career"
      ],
      skills: ["Excel", "SQL", "Power BI", "Data Analysis", "Business Intelligence", "Reporting"],
      projects: "Sales analysis, User behavior reports, Performance dashboards"
    },
    {
      id: 24,
      title: "Product Management Internship",
      department: "Product",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "₹20,000 - ₹35,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn product management, roadmap planning, and work with product teams.",
      responsibilities: [
        "Assist in product strategy and planning",
        "Conduct user research and feedback analysis",
        "Create product requirement documents",
        "Work with design and development teams",
        "Track product metrics and analytics",
        "Support product launches"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong analytical and communication skills",
        "Interest in product management",
        "Technical understanding",
        "Problem-solving mindset"
      ],
      learningOutcomes: [
        "Learn product management fundamentals",
        "Understand product lifecycle",
        "Work with cross-functional teams",
        "Learn prioritization frameworks",
        "Gain real product experience",
        "Build PM career foundation"
      ],
      skills: ["Product Management", "Analytics", "User Research", "Roadmap Planning", "Communication", "Agile"],
      projects: "Feature planning, User research, Product documentation"
    },
    {
      id: 25,
      title: "Graphic Design Internship",
      department: "Design",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹28,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Create visual designs, graphics, and branding materials for real company projects.",
      responsibilities: [
        "Design social media graphics and posters",
        "Create marketing materials and banners",
        "Design course thumbnails and certificates",
        "Work on brand identity projects",
        "Use Adobe Photoshop, Illustrator",
        "Collaborate with marketing team"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Proficiency in Adobe Creative Suite",
        "Creative and artistic skills",
        "Eye for design and aesthetics",
        "Portfolio of design work (preferred)"
      ],
      learningOutcomes: [
        "Master graphic design tools",
        "Learn brand design principles",
        "Build professional design portfolio",
        "Work on real design projects",
        "Understand visual communication",
        "Develop creative career"
      ],
      skills: ["Graphic Design", "Adobe Photoshop", "Illustrator", "Brand Design", "Visual Design", "Typography"],
      projects: "Social media graphics, Marketing materials, Brand assets"
    },
    {
      id: 26,
      title: "Natural Language Processing (NLP) Internship",
      department: "AI/ML",
      location: "Remote",
      duration: "4-6 months",
      stipend: "₹25,000 - ₹42,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Work on text analysis, chatbots, and NLP projects for real company applications.",
      responsibilities: [
        "Build NLP models for text classification",
        "Work on sentiment analysis projects",
        "Develop chatbots and conversational AI",
        "Implement text preprocessing pipelines",
        "Work with transformers and BERT",
        "Create NLP-based educational tools"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Strong Python programming",
        "Understanding of NLP concepts",
        "Interest in language and AI",
        "Basic ML knowledge"
      ],
      learningOutcomes: [
        "Master NLP with Python",
        "Learn transformers and BERT",
        "Build chatbots and text analysis tools",
        "Work on real NLP projects",
        "Understand language models",
        "Create NLP portfolio"
      ],
      skills: ["Python", "NLP", "NLTK", "spaCy", "Transformers", "Text Analysis"],
      projects: "Sentiment analysis tool, Chatbot, Text summarization"
    },
    {
      id: 27,
      title: "Database Management Internship",
      department: "Data Engineering",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹18,000 - ₹30,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn database design, SQL, and work with real company databases.",
      responsibilities: [
        "Design and optimize database schemas",
        "Write complex SQL queries",
        "Work with MySQL, PostgreSQL, MongoDB",
        "Implement database backup strategies",
        "Monitor database performance",
        "Learn database security"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Basic SQL knowledge",
        "Understanding of databases",
        "Logical thinking",
        "Attention to detail"
      ],
      learningOutcomes: [
        "Master SQL and database design",
        "Learn MySQL, PostgreSQL, MongoDB",
        "Understand database optimization",
        "Work on real database projects",
        "Learn backup and recovery",
        "Build database expertise"
      ],
      skills: ["SQL", "MySQL", "PostgreSQL", "MongoDB", "Database Design", "Query Optimization"],
      projects: "Database design, Data migration, Performance optimization"
    },
    {
      id: 28,
      title: "API Development Internship",
      department: "Backend Engineering",
      location: "Remote",
      duration: "3-6 months",
      stipend: "₹18,000 - ₹32,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build RESTful APIs and GraphQL endpoints for real company applications.",
      responsibilities: [
        "Develop REST APIs using Node.js or Python",
        "Implement authentication and authorization",
        "Create API documentation",
        "Write API tests",
        "Optimize API performance",
        "Work with databases and caching"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Knowledge of Node.js or Python",
        "Understanding of REST APIs",
        "Basic database knowledge",
        "Problem-solving skills"
      ],
      learningOutcomes: [
        "Master API development",
        "Learn REST and GraphQL",
        "Build secure APIs",
        "Work on real API projects",
        "Understand API design patterns",
        "Create API portfolio"
      ],
      skills: ["REST API", "Node.js", "Python", "API Design", "Authentication", "Documentation"],
      projects: "Mobile app API, Microservices, GraphQL server"
    },
    {
      id: 29,
      title: "Automation Testing Internship",
      department: "Quality Assurance",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹18,000 - ₹30,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Learn test automation frameworks and tools for real company testing projects.",
      responsibilities: [
        "Write automated test scripts",
        "Use Selenium, Cypress, or Playwright",
        "Implement CI/CD integration for tests",
        "Perform API automation testing",
        "Create test frameworks",
        "Report and track defects"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "Programming knowledge (Java/Python/JavaScript)",
        "Interest in software testing",
        "Analytical mindset",
        "Detail-oriented"
      ],
      learningOutcomes: [
        "Master test automation tools",
        "Learn Selenium and Cypress",
        "Build test frameworks",
        "Work on real automation projects",
        "Understand CI/CD testing",
        "Build automation testing career"
      ],
      skills: ["Selenium", "Cypress", "Test Automation", "Java", "Python", "CI/CD"],
      projects: "Web automation framework, API test suite, Mobile test automation"
    },
    {
      id: 30,
      title: "WordPress Development Internship",
      department: "Web Development",
      location: "Remote",
      duration: "3-5 months",
      stipend: "₹15,000 - ₹25,000",
      eligibleYear: "2nd, 3rd Year (B.Tech/B.E), M.Tech All Years, Career Gap (2-3 years)",
      description: "Build and customize WordPress websites for real company clients.",
      responsibilities: [
        "Develop WordPress websites and themes",
        "Customize plugins and themes",
        "Optimize website performance",
        "Implement SEO best practices",
        "Work with page builders (Elementor, WPBakery)",
        "Provide website maintenance"
      ],
      requirements: [
        "Currently enrolled in 2nd/3rd year B.Tech/B.E or M.Tech (any stream)",
        "Career gap candidates (2-3 years) welcome",
        "HTML, CSS, PHP basics",
        "Interest in WordPress development",
        "Creative problem-solving",
        "Attention to detail"
      ],
      learningOutcomes: [
        "Master WordPress development",
        "Learn theme and plugin development",
        "Build custom WordPress sites",
        "Work on real client projects",
        "Understand CMS platforms",
        "Build freelancing skills"
      ],
      skills: ["WordPress", "PHP", "HTML/CSS", "JavaScript", "Theme Development", "SEO"],
      projects: "Business websites, Blog development, E-commerce sites"
    }
  ];

  useEffect(() => {
    setFilteredInternships(internshipListings);
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredInternships(internshipListings);
    } else {
      const filtered = internshipListings.filter(internship =>
        internship.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        internship.department.toLowerCase().includes(searchTerm.toLowerCase()) ||
        internship.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
        internship.eligibleYear.toLowerCase().includes(searchTerm.toLowerCase()) ||
        internship.skills.some(skill => skill.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredInternships(filtered);
    }
  }, [searchTerm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'internshipApplications'), {
        ...formData,
        internshipRole: selectedInternship.title,
        appliedAt: new Date().toISOString(),
        status: 'pending'
      });
      setSubmitSuccess(true);
      setTimeout(() => {
        setShowModal(false);
        setShowApplicationForm(false);
        setSubmitSuccess(false);
        setFormData({
          name: '',
          email: '',
          mobile: '',
          college: '',
          degree: '',
          branch: '',
          year: '',
          cgpa: '',
          careerGap: '',
          gapReason: '',
          skills: '',
          previousInternships: '',
          projects: '',
          linkedin: '',
          github: '',
          portfolio: '',
          whyApply: '',
          availability: ''
        });
      }, 3000);
    } catch (error) {
      console.error("Error submitting application:", error);
      alert("Error submitting application. Please try again or contact us directly.");
    }
  };

  const openInternshipDetails = (internship) => {
    setSelectedInternship(internship);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowApplicationForm(false);
  };

  const openApplicationForm = () => {
    setShowApplicationForm(true);
  };

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      
      <div className="min-vh-100 py-5" style={{ backgroundColor: '#00468dff' }}>
        {/* Header Section */}
        <div className="text-white py-5" style={{ background: 'linear-gradient(135deg, #08407aff 0%, #0d914fff 100%)' }}>
          <div className="container">
            <h1 className="display-4 fw-bold mb-3 animate__animated animate__fadeIn">
               Paid Internship Opportunities
            </h1>
            <p className="lead mb-4">
              Real-time company projects • Hands-on learning • Earn while you learn
            </p>
            <div className="row g-3 mb-3">
              <div className="col-md-3 col-6">
                <div className="d-flex align-items-center gap-2">
                  <Briefcase size={20} />
                  <span className="small">30+ Internships</span>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="d-flex align-items-center gap-2">
                  <span className="small">₹15k - ₹50k</span>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="d-flex align-items-center gap-2">
                  <GraduationCap size={20} />
                  <span className="small">All Streams are Eligible for Our Projects</span>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="d-flex align-items-center gap-2">
                  <MapPin size={20} />
                  <span className="small">Remote & Hybrid</span>
                </div>
              </div>
            </div>
            <div className="alert alert-light border-0 shadow-sm d-inline-block">
              <div className="d-flex flex-wrap align-items-center gap-3 small">
                <div className="d-flex align-items-center gap-2">
                  <Phone size={16} />
                  <span className="fw-semibold">{contactNumber}</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <Mail size={16} />
                  <span className="fw-semibold">{contactEmail}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Eligibility Banner */}
        <div className="container mt-4">
          <div className="card border-0 shadow-sm mb-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <div className="card-body text-white p-4">
              <h3 className=" fw-bold mb-3 text-center me-3 gap-2">
                Who Can Apply?
              </h3>
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <CheckCircle size={20} className="flex-shrink-0 mt-1" />
                    <div>
                      <div className="fw-semibold">B.Tech / B.E Students</div>
                      <div className="small opacity-90">2nd Year & 3rd Year (All Streams)</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <CheckCircle size={20} className="flex-shrink-0 mt-1" />
                    <div>
                      <div className="fw-semibold">M.Tech Students</div>
                      <div className="small opacity-90">All Years (All Streams)</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <CheckCircle size={20} className="flex-shrink-0 mt-1" />
                    <div>
                      <div className="fw-semibold">Career Gap Candidates</div>
                      <div className="small opacity-90">2-3 Years Gap Welcome</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="container">
          <div className="card shadow border-0 mb-4">
            <div className="card-body p-4">
              <div className="position-relative">
                <Search className="position-absolute" style={{ left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }} size={20} />
                <input
                  type="text"
                  placeholder="Search by technology, domain, skills, or year..."
                  className="form-control form-control-lg ps-5"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="mt-3 d-flex justify-content-between align-items-center">
                <span className="text-muted small">{filteredInternships.length} internships available</span>
                <div className="d-flex gap-2">
                  <span className="badge bg-success">Paid Internships</span>
                  <span className="badge bg-primary">Real Projects</span>
                  <span className="badge bg-info">Certificate Provided</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Internship Listings */}
        <div className="container pb-5">
          <div className="row g-4">
            {filteredInternships.map((internship, index) => (
              <div key={internship.id} className="col-12">
                <div className="card h-100 border-0 shadow-sm hover-shadow transition-all">
                  <div className="card-body p-4">
                    <div className="row">
                      <div className="col-lg-9 col-md-8">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <h3 className="card-title h5 fw-bold text-dark mb-0">
                            {internship.title}
                          </h3>
                          <span className="badge text-white px-3 py-2 fs-6" style={{ background: 'linear-gradient(135deg, #00bc65ff 0%, #00cc69ff 100%)' }}>
                           {internship.stipend}
                          </span>
                        </div>
                        <p className="card-text text-muted mb-3" style={{ 
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden'
                        }}>
                          {internship.description}
                        </p>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                          <span className="badge bg-primary d-flex align-items-center gap-1">
                            <Briefcase size={14} />
                            {internship.department}
                          </span>
                          <span className="badge bg-success d-flex align-items-center gap-1">
                            <MapPin size={14} />
                            {internship.location}
                          </span>
                          <span className="badge bg-info d-flex align-items-center gap-1">
                            <Clock size={14} />
                            {internship.duration}
                          </span>
                        </div>
                        <div className="mb-3">
                          <div className="small text-muted mb-1">
                            <GraduationCap size={16} className="mb-1" /> <strong>Eligible:</strong> {internship.eligibleYear}
                          </div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {internship.skills.slice(0, 4).map((skill, idx) => (
                            <span key={idx} className="badge bg-light text-dark border">
                              {skill}
                            </span>
                          ))}
                          {internship.skills.length > 4 && (
                            <span className="badge bg-light text-dark border">
                              +{internship.skills.length - 4} more
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
                        <button
                          onClick={() => openInternshipDetails(internship)}
                          className="btn btn-lg fw-semibold w-100 w-md-auto text-white"
                          style={{ background: 'linear-gradient(135deg, #0068e8ff 0%, #0030b4ff 100%)' }}
                        >
                          View & Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredInternships.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted fs-5">
                No internships found matching your search. Try different keywords.
              </p>
            </div>
          )}
        </div>

        {/* Internship Details Modal */}
        {showModal && selectedInternship && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header border-bottom" style={{ background: 'linear-gradient(135deg, #000000ff 0%, #008bf5ff 100%)' }}>
                  <div className="text-white">
                    <h2 className="modal-title h4 fw-bold mb-2">
                      {selectedInternship.title}
                    </h2>
                    <div className="d-flex flex-wrap gap-2">
                      <span className="badge bg-white text-dark d-flex align-items-center gap-1">
                        <Briefcase size={14} />
                        {selectedInternship.department}
                      </span>
                      <span className="badge bg-white text-dark d-flex align-items-center gap-1">
                        <MapPin size={14} />
                        {selectedInternship.location}
                      </span>
                      <span className="badge bg-white text-dark d-flex align-items-center gap-1">
                        <Clock size={14} />
                        {selectedInternship.duration}
                      </span>
                      <span className="badge bg-white text-dark d-flex align-items-center gap-1">
                        {selectedInternship.stipend}
                      </span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={closeModal}
                  ></button>
                </div>

                {!showApplicationForm ? (
                  <div className="modal-body">
                    <div className="alert alert-info border-info mb-4">
                      <div className="d-flex align-items-start gap-2">
                        <GraduationCap size={24} className="flex-shrink-0" />
                        <div>
                          <h4 className="h6 fw-bold mb-1">Eligibility</h4>
                          <p className="mb-0 small">{selectedInternship.eligibleYear}</p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3 d-flex align-items-center gap-2">
                        <BookOpen size={20} />
                        About this Internship
                      </h3>
                      <p className="text-muted">{selectedInternship.description}</p>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Your Responsibilities</h3>
                      <ul className="list-unstyled">
                        {selectedInternship.responsibilities.map((item, idx) => (
                          <li key={idx} className="d-flex gap-2 mb-2">
                            <CheckCircle size={20} className="text-success flex-shrink-0 mt-1" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Requirements</h3>
                      <ul className="list-unstyled">
                        {selectedInternship.requirements.map((item, idx) => (
                          <li key={idx} className="d-flex gap-2 mb-2">
                            <CheckCircle size={20} className="text-primary flex-shrink-0 mt-1" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3 d-flex align-items-center gap-2">
                        <Award size={20} />
                        What You'll Learn
                      </h3>
                      <ul className="list-unstyled">
                        {selectedInternship.learningOutcomes.map((item, idx) => (
                          <li key={idx} className="d-flex gap-2 mb-2">
                            <CheckCircle size={20} className="text-warning flex-shrink-0 mt-1" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Skills You'll Work With</h3>
                      <div className="d-flex flex-wrap gap-2">
                        {selectedInternship.skills.map((skill, idx) => (
                          <span key={idx} className="badge text-white px-3 py-2" style={{ background: 'linear-gradient(135deg, #0054aeff 0%, #009d57ff 100%)' }}>
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Projects You'll Work On</h3>
                      <div className="alert alert-light border">
                        <p className="mb-0">{selectedInternship.projects}</p>
                      </div>
                    </div>

                    <div className="alert alert-primary border-primary mb-4">
                      <h4 className="h6 fw-bold mb-2">Contact Information</h4>
                      <div className="d-flex flex-column gap-2 small">
                        <div className="d-flex align-items-center gap-2">
                          <Phone size={16} />
                          <span>Phone: {contactNumber}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Mail size={16} />
                          <span>Email: {contactEmail}</span>
                        </div>
                      </div>
                      <p className="small mb-0 mt-2">
                        Have questions? Feel free to reach out before applying!
                      </p>
                    </div>

                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <div className="card bg-light border-0">
                          <div className="card-body">
                            <div className="d-flex align-items-center gap-3">
                              <div>
                                <div className="small text-muted">Stipend Range</div>
                                <div className="fw-bold">{selectedInternship.stipend}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card bg-light border-0">
                          <div className="card-body">
                            <div className="d-flex align-items-center gap-3">
                              <Calendar size={32} className="text-primary" />
                              <div>
                                <div className="small text-muted">Duration</div>
                                <div className="fw-bold">{selectedInternship.duration}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={openApplicationForm}
                      className="btn btn-lg w-100 text-white fw-bold"
                      style={{ background: 'linear-gradient(135deg, #000000ff 0%, #000000ff 100%)' }}
                    >
                      Apply for this Internship
                    </button>
                  </div>
                ) : (
                  <div className="modal-body">
                    {submitSuccess ? (
                      <div className="text-center py-5">
                        <CheckCircle size={64} className="text-success mb-3" />
                        <h3 className="h4 fw-bold mb-2">Application Submitted Successfully!</h3>
                        <p className="text-muted">
                          We'll review your application and get back to you within 2-3 business days.
                        </p>
                      </div>
                    ) : (
                      <>
                        <h3 className="h4 fw-bold mb-4">Apply for {selectedInternship.title}</h3>
                        <form onSubmit={handleSubmit}>
                          <div className="row g-3">
                            <div className="col-12">
                              <h5 className="h6 fw-bold mb-3 text-primary">Personal Information</h5>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Full Name *</label>
                              <input
                                type="text"
                                name="name"
                                required
                                value={formData.name}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="John Doe"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Email Address *</label>
                              <input
                                type="email"
                                name="email"
                                required
                                value={formData.email}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="john@example.com"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Mobile Number *</label>
                              <input
                                type="tel"
                                name="mobile"
                                required
                                value={formData.mobile}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="+91 9876543210"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">College/University Name *</label>
                              <input
                                type="text"
                                name="college"
                                required
                                value={formData.college}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Your College Name"
                              />
                            </div>

                            <div className="col-12 mt-4">
                              <h5 className="h6 fw-bold mb-3 text-primary">Educational Details</h5>
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">Degree *</label>
                              <select
                                name="degree"
                                required
                                value={formData.degree}
                                onChange={handleInputChange}
                                className="form-select"
                              >
                                <option value="">Select Degree</option>
                                <option value="B.Tech">B.Tech</option>
                                <option value="B.E">B.E</option>
                                <option value="M.Tech">M.Tech</option>
                                <option value="MCA">MCA</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">Branch/Stream *</label>
                              <input
                                type="text"
                                name="branch"
                                required
                                value={formData.branch}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="e.g., CSE, ECE, Mechanical"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">Current Year *</label>
                              <select
                                name="year"
                                required
                                value={formData.year}
                                onChange={handleInputChange}
                                className="form-select"
                              >
                                <option value="">Select Year</option>
                                <option value="2nd Year">2nd Year</option>
                                <option value="3rd Year">3rd Year</option>
                                <option value="4th Year">4th Year</option>
                                <option value="M.Tech 1st Year">M.Tech 1st Year</option>
                                <option value="M.Tech 2nd Year">M.Tech 2nd Year</option>
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">CGPA/Percentage *</label>
                              <input
                                type="text"
                                name="cgpa"
                                required
                                value={formData.cgpa}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="e.g., 8.5 or 75%"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Career Gap (if any)</label>
                              <select
                                name="careerGap"
                                value={formData.careerGap}
                                onChange={handleInputChange}
                                className="form-select"
                              >
                                <option value="">No Career Gap</option>
                                <option value="1 year">1 Year</option>
                                <option value="2 years">2 Years</option>
                                <option value="3 years">3 Years</option>
                              </select>
                            </div>
                            {formData.careerGap && (
                              <div className="col-12">
                                <label className="form-label fw-semibold">Reason for Career Gap</label>
                                <textarea
                                  name="gapReason"
                                  value={formData.gapReason}
                                  onChange={handleInputChange}
                                  rows="2"
                                  className="form-control"
                                  placeholder="Brief reason for the gap..."
                                />
                              </div>
                            )}

                            <div className="col-12 mt-4">
                              <h5 className="h6 fw-bold mb-3 text-primary">Skills & Experience</h5>
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Relevant Skills *</label>
                              <textarea
                                name="skills"
                                required
                                value={formData.skills}
                                onChange={handleInputChange}
                                rows="3"
                                className="form-control"
                                placeholder="e.g., Python, React.js, Machine Learning, etc."
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Previous Internships/Experience</label>
                              <textarea
                                name="previousInternships"
                                value={formData.previousInternships}
                                onChange={handleInputChange}
                                rows="3"
                                className="form-control"
                                placeholder="Mention any previous internships or work experience..."
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Projects You've Built *</label>
                              <textarea
                                name="projects"
                                required
                                value={formData.projects}
                                onChange={handleInputChange}
                                rows="3"
                                className="form-control"
                                placeholder="Describe 2-3 projects you've worked on..."
                              />
                            </div>

                            <div className="col-12 mt-4">
                              <h5 className="h6 fw-bold mb-3 text-primary">Online Profiles</h5>
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">LinkedIn Profile</label>
                              <input
                                type="url"
                                name="linkedin"
                                value={formData.linkedin}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="https://linkedin.com/in/yourprofile"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">GitHub Profile</label>
                              <input
                                type="url"
                                name="github"
                                value={formData.github}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="https://github.com/yourusername"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">Portfolio/Website</label>
                              <input
                                type="url"
                                name="portfolio"
                                value={formData.portfolio}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="https://yourportfolio.com"
                              />
                            </div>

                            <div className="col-12 mt-4">
                              <h5 className="h6 fw-bold mb-3 text-primary">Additional Information</h5>
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Why do you want this internship? *</label>
                              <textarea
                                name="whyApply"
                                required
                                value={formData.whyApply}
                                onChange={handleInputChange}
                                rows="4"
                                className="form-control"
                                placeholder="Tell us what excites you about this internship and how it aligns with your career goals..."
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Availability *</label>
                              <select
                                name="availability"
                                required
                                value={formData.availability}
                                onChange={handleInputChange}
                                className="form-select"
                              >
                                <option value="">Select Availability</option>
                                <option value="Immediate">Immediate</option>
                                <option value="Within 1 week">Within 1 week</option>
                                <option value="Within 2 weeks">Within 2 weeks</option>
                                <option value="Within 1 month">Within 1 month</option>
                              </select>
                            </div>
                          </div>
                          <div className="d-flex gap-3 mt-4">
                            <button
                              type="button"
                              onClick={() => setShowApplicationForm(false)}
                              className="btn btn-secondary btn-lg flex-fill"
                            >
                              Back to Details
                            </button>
                            <button
                              type="submit"
                              className="btn btn-lg flex-fill text-white fw-semibold"
                              style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}
                            >
                              Submit Application
                            </button>
                          </div>
                        </form>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Benefits Section */}
        <div className="bg-white py-5 border-top">
          <div className="container">
            <h3 className="h4 fw-bold text-center mb-4">Why Intern With Us?</h3>
            <div className="row g-4">
              <div className="col-md-3 col-6">
                <div className="text-center">
                  <div className="mb-3">
                    <Award size={40} className="text-primary" />
                  </div>
                  <h4 className="h6 fw-bold">Real Projects</h4>
                  <p className="small text-muted mb-0">Work on live company projects</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="text-center">
                  <div className="mb-3">
                    <FaRupeeSign size={40} className="text-success" />
                  </div>
                  <h4 className="h6 fw-bold">Paid Stipend</h4>
                  <p className="small text-muted mb-0">₹15,000 - ₹50,000 per project</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="text-center">
                  <div className="mb-3">
                    <Users size={40} className="text-warning" />
                  </div>
                  <h4 className="h6 fw-bold">Mentorship</h4>
                  <p className="small text-muted mb-0">Learn from industry experts</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="text-center">
                  <div className="mb-3">
                    <BookOpen size={40} className="text-info" />
                  </div>
                  <h4 className="h6 fw-bold">Certificate</h4>
                  <p className="small text-muted mb-0">Completion certificate provided</p>
                </div>
              </div>
            </div>
          </div>
        </div>

     
      </div>

      <style>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          transform: translateY(-2px);
        }
        .transition-all {
          transition: all 0.3s ease;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate__animated {
          animation-duration: 0.6s;
        }
        .animate__fadeIn {
          animation-name: fadeIn;
        }
        .card {
          animation: slideIn 0.4s ease-out;
        }
        .modal.show {
          display: block;
          animation: fadeIn 0.3s ease-out;
        }
        .badge {
          font-weight: 500;
        }
        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
        .form-control:focus, .form-select:focus {
          border-color: #f093fb;
          box-shadow: 0 0 0 0.25rem rgba(240, 147, 251, 0.25);
        }
        .list-unstyled li {
          padding: 0.5rem 0;
        }
      `}</style>

      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
    </>
  );
};

export default InternshipsPortal;